























































import BaseComponent from '@/components/base-component.vue';
import { getLockPrescriptionReasons } from '@/services/parameters';
import * as service from '@/services/prescription';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  components: {},
  directives: {}
})
export default class LockPrescriptionDialog extends BaseComponent {
  @Prop()
  item: any;

  @Prop()
  opcaoExcluir;

  dialogFlag = false;
  reasons: any[] = [];
  reason: any = null;
  description: string = null;
  formOpen = false;
  loadingReasons = false;
  group = [];
  ids = [];
  loadingGroup = false;

  public $refs!: {
    form: HTMLFormElement;
  };

  public rules: any = {
    reason: [(v) => (!!v && !!v.id) || 'Selecione um motivo']
  };

  public form: any = {
    valid: false
  };

  public beforeMount(): void {
    const filter = {
      idMedico: this.item.medico.id,
      idUnidade: this.item.unidade.id
    };

    this.loadingReasons = true;
    getLockPrescriptionReasons(filter).subscribe((data) => {
      this.reasons = data.valores || [];
      this.loadingReasons = false;
    });

    this.loadGroup();
  }

  private loadGroup() {
    this.loadingGroup = true;
    service.getLockPrescriptionGroup(this.item.idPrescricao).subscribe(
      (res) => {
        this.loadingGroup = false;
        this.group = res;
      },
      (error) => {
        this.loadingGroup = false;
        this.showToastApiError(error);
      }
    );
  }

  mounted() {
    this.formOpen = true;
  }

  private getLabelBotaoQtdePresc() {
    if ((this.item && this.item.quantidade && this.item.quantidade > 1) || this.ids.length) {
      return ` ( ${this.item.quantidade * (this.ids.length + 1)} Prescrições )`;
    }
    return '';
  }

  public lockPrescription(): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    this.loader.start('Bloqueando ...');

    var observable = null;
    let parm = new service.PrescricaoBloqueioParmDTO();
    parm.idsPrescricao = Object.assign(new Array(), this.ids);
    parm.idsPrescricao.push(this.item.idPrescricao);
    parm.idMotivo = this.reason.id;
    parm.descricao = this.description;
    observable = service.lockPrescriptions(parm);
    this.addSubsc(
      observable.subscribe(
        (data) => {
          this.loader.stop();
          this.closeForm();
          this.$emit('lockPrescription');
        },
        (error) => {
          this.loader.stop();
          this.showToastApiError(error);
        }
      )
    );
  }

  closeForm() {
    this.$emit('close');
    this.dialogFlag = false;
  }

  selectAll() {
    this.ids = this.group.map((g) => g.id);
  }

  removeAllSelected() {
    this.ids = [];
  }
}
